function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Instant Renting");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Online-Booking",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instant-Renting-mobile-web",
  transform: "translate(-40.000000, -523.000000)",
  fillRule: "nonzero",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(22.000000, 431.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instant-Renting",
  transform: "translate(18.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.464722,9 C16.1516497,9 15.9091919,9.2350261 15.9091919,9.54136053 L15.9091919,16.9361105 L11.9698041,16.9361105 L11.9698041,13.9165326 C11.9698041,13.6332622 11.7273779,13.3856306 11.4343057,13.3856306 L8.58594639,13.3856306 C8.27262215,13.3856306 8.02027456,13.6332316 8.02027456,13.9165326 L8.02027456,16.9361105 L4.09080806,16.9361105 L4.09080806,9.78687586 C4.09080806,9.50145854 3.84860224,9.26437753 3.535278,9.26437753 C3.24242629,9.26437753 3,9.50145854 3,9.78687586 L3,17.4775017 C3,17.7628883 3.24242629,18 3.535278,18 L8.58594639,18 C8.8787981,18 9.12122439,17.7628883 9.12122439,17.4775017 L9.12122439,14.4578932 L10.8787441,14.4578932 L10.8787441,17.4775017 C10.8787441,17.7628883 11.1211704,18 11.4343057,18 L16.464722,18 C16.7576052,18 17,17.7628883 17,17.4775017 L17,9.5413912 C17,9.23505677 16.7576052,9 16.464722,9 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8367969,9.09128082 L15.2882769,4.79385722 L15.2882769,1.86370903 C15.2882769,1.55869151 15.0262167,1.32312611 14.7013457,1.32312611 C14.3972592,1.32312611 14.1457547,1.55872225 14.1457547,1.86370903 L14.1457547,3.71899404 L10.3937093,0.168296132 C10.2787414,0.0589067208 10.1421721,0 10.0059949,0 C9.84880455,0 9.7124313,0.060997356 9.59726731,0.168296132 L0.1751929,9.0323741 C-0.05085401,9.24481953 -0.0658214069,9.58559306 0.1751929,9.78122118 C0.384703777,10.0083933 0.745587978,9.99366661 0.971634888,9.78122118 L10.0059949,1.30206604 L19.0193417,9.86115723 C19.1132311,9.94951731 19.2498658,10 19.4280693,10 C19.5852597,10 19.7214041,9.94951731 19.8367969,9.86115723 C20.0465038,9.66343848 20.0621575,9.30584763 19.8367969,9.09128082 Z",
  id: "Shape"
})))));

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.ec07b321.svg";
export { ForwardRef as ReactComponent };